import { render, staticRenderFns } from "./ResizerColumn.vue?vue&type=template&id=776f7f00"
import script from "./ResizerColumn.vue?vue&type=script&lang=js"
export * from "./ResizerColumn.vue?vue&type=script&lang=js"
import style0 from "./ResizerColumn.vue?vue&type=style&index=0&id=776f7f00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports